import React from "react";

const UserProfileCard = ({
  name = "Nom utilisateur",
  role = "Fonction",
  avatarUrl,
}) => {
  return (
    <div className="p-2 rounded-xl flex flex-col items-center w-full max-w-xs mx-auto">
      {/* Avatar arrondi */}
      <div className="w-32 h-32 rounded-full overflow-hidden mb-4">
        <img
          src={avatarUrl}
          alt={`Photo de ${name}`}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Nom */}
      <h2 className="text-sm font-bold text-gray-900 text-center">{name}</h2>

      {/* Fonction */}
      <p className="text-sm text-orange-500 font-semibold text-center">
        {role}
      </p>
    </div>
  );
};

export default UserProfileCard;
